import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Options from './options.mdx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The `}<a parentName="p" {...{
        "href": "/react-sim/api#common-controls-props"
      }}>{`Common controls props`}</a>{` properties, plus:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`vertical`}</strong><br />{`boolean, optional, false by default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Whether the options are shown horizontally or vertically.`}</td>
        </tr>
      </tbody>
    </table>
    <Options mdxType="Options" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      